<app-errorlist></app-errorlist>
<app-key-value-table [keyValues]="keyValues"></app-key-value-table>

<mat-card appearance="outlined">
  <mat-card-content>
    @if (rooms(); as rooms) {
      <div>
        <p>{{ "components.detail-information.room-list" | translate }}</p>
        @for (room of rooms; track $index) {
          <div class="error-list">
            <mat-icon [style.color]="room.color">{{ room.icon }}</mat-icon
            ><span>{{ room.name }}</span>
          </div>
        }
      </div>
    }
    @if (selfCreatedRooms(); as selfCreatedRooms) {
      <div>
        @if (selfCreatedRooms.length > 0) {
          <div>
            <p>
              {{
                "components.detail-information.self-created-room-list"
                  | translate
              }}
            </p>
            @for (room of selfCreatedRooms; track room.name) {
              <div class="error-list">
                <mat-icon [style.color]="room.color">{{ room.icon }}</mat-icon
                ><span>{{ room.name }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
